import { ApiRequest } from "@plinknz/tah-website-elements";
import { membersLogin } from "../../../config/router";

export const maraeApi = new ApiRequest({
    baseUrl: process.env.MARAE_FORM_URL || "https://localhost:3001",
    loginPath: membersLogin(),
    credentials: "same-origin",
});
